<template functional>
  <transition name="fade">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'FadeTransition',
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-40px);

  @include mq('sm') {
    transform: translateY(0);
  }
}
</style>
